import React from "react";
import { CheckCircle, Circle } from "lucide-react";

type PasswordCheckerProps = {
  password: string;
};

const passwordChecks = [
  {
    label: "At least 8 characters",
    test: (pw: string) => pw.length >= 8,
  },
  {
    label: "At least one uppercase letter (A-Z)",
    test: (pw: string) => /[A-Z]/.test(pw),
  },
  {
    label: "At least one lowercase letter (a-z)",
    test: (pw: string) => /[a-z]/.test(pw),
  },
  {
    label: "At least one number (0–9)",
    test: (pw: string) => /[0-9]/.test(pw),
  },
  {
    label: "At least one special character (!@#$%^&*)",
    test: (pw: string) => /[!@#$%^&*]/.test(pw),
  },
];

const FleetrifyPasswordChecker: React.FC<PasswordCheckerProps> = ({
  password,
}) => {
  return (
    <div className="space-y-2 mt-4">
      {passwordChecks.map((item, index) => {
        const isPassed = item.test(password);
        return (
          <div
            key={index}
            className="flex items-center gap-2 text-xs transition-colors duration-300"
          >
            {isPassed ? (
              <CheckCircle
                className="text-green-500 w-5 h-5 transition-transform duration-300 transform scale-100"
                style={{ transitionProperty: "color, transform" }}
                aria-label="passed"
              />
            ) : (
              <Circle
                className="text-gray-400 w-5 h-5 transition-transform duration-300 transform scale-90"
                style={{ transitionProperty: "color, transform" }}
                aria-label="not passed"
              />
            )}
            <span
              className={`transition-colors duration-300 ${
                isPassed ? "text-green-600" : "text-gray-600"
              }`}
            >
              {item.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default FleetrifyPasswordChecker;
